import { css } from "@emotion/react";
import { theme } from "@polifonia/theme";
import { useTranslation } from "react-i18next";

import { ExternalLink } from "@/components/ExternalLink";

const cssContainer = css`
  padding: 16px;
  background-color: ${theme.colors.staticBgContainer};
  border-radius: 8px;
`;

const cssLink = css`
  font-size: 0.875rem;
`;

export const DownloadTemplates: React.FC = function DownloadTemplates() {
  const { t } = useTranslation();

  return (
    <div css={cssContainer}>
      <ExternalLink
        href={t("applications.productFeed.templateURL")}
        trailingIcon={true}
        css={cssLink}
      >
        {t("common.downloadTemplate")}
      </ExternalLink>
    </div>
  );
};
